import React from 'react';
import styles from './AnimatedWaitIcon.module.scss';
import clsx from 'clsx';
export function AnimatedWaitIcon({ className, animationType, size = 'default', color }) {
    const style = color !== undefined ? {
        '--dot-color': color
    } : undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.ellipsis, styles[animationType], styles[size], className),
        style: style
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.dot
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.dot
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.dot
    }));
}
